import React from 'react';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetDescription,
} from '@/components/ui/sheet';
import { ShieldQuestion } from 'lucide-react';
import { ArticleFAQPanel } from '@/components/articles/ArticleFAQPanel';
import type { ArticleFAQ } from '@/types/articles';

interface ArticleFAQDrawerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  focusKeyword: string;
  faqs: ArticleFAQ[];
  slug: string;
  onUpdateFaqs: (faqs: ArticleFAQ[]) => void;
  onInsertFAQSchema: (validatedFaqs: ArticleFAQ[]) => void;
}

export const ArticleFAQDrawer: React.FC<ArticleFAQDrawerProps> = ({
  open,
  onOpenChange,
  focusKeyword,
  faqs,
  slug,
  onUpdateFaqs,
  onInsertFAQSchema,
}) => {
  return (
    <Sheet open={open} onOpenChange={onOpenChange} modal={false}>
      <SheetContent side="right" className="w-[480px] sm:max-w-[480px] flex flex-col p-0 mr-12" style={{ zIndex: 60 }}>
        <SheetHeader className="px-6 pt-6 pb-4 border-b shrink-0">
          <SheetTitle className="flex items-center gap-2">
            <ShieldQuestion className="h-5 w-5 text-primary" />
            FAQs
          </SheetTitle>
          <SheetDescription>Fetch People Also Ask questions and generate FAQ answers</SheetDescription>
        </SheetHeader>

        <div className="flex-1 min-h-0">
          <ArticleFAQPanel
            focusKeyword={focusKeyword}
            faqs={faqs}
            slug={slug}
            onUpdateFaqs={onUpdateFaqs}
            onInsertFAQSchema={onInsertFAQSchema}
            onClose={() => onOpenChange(false)}
          />
        </div>
      </SheetContent>
    </Sheet>
  );
};
